import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Toaster } from '../../components/ui/sonner';

export const Layout = () => {
  return (
    <div className="min-h-screen bg-white">
      <Sidebar />
      
      {/* Main content - adjusts to collapsed sidebar */}
      <main className="lg:pl-14 transition-all duration-300">
        {/* Spacer for mobile header (incluye safe area de la barra de estado) */}
        <div className="mobile-header-spacer lg:hidden" />
        
        {/* Page content */}
        <div className="animate-fadeIn">
          <Outlet />
        </div>
      </main>
      
      <Toaster position="top-right" richColors offset="calc(1rem + env(safe-area-inset-top))" />
    </div>
  );
};

export default Layout;
